import { useParams } from 'react-router-dom'
import PaymentForm from './PaymentForm'

const View = () => {
    const params = useParams()

    return (
        <PaymentForm
            id={parseInt(params.paymentId)}
            config={{
                submitSuccessMsg: {
                    header: 'Updated',
                    message: 'Payment updated successfully',
                },
                submitFailedMsg: {
                    header: 'Failed',
                    message: 'Failed to update payment',
                },
                saveButton: {
                    label: 'Update',
                    savingLabel: 'Updating payment...',
                },
            }}
        />
    )
}

export default View
